const EditItem1 = (props) => {
    const handleEditClick = () => {
        props.onClickEditBlock(props);
    };
  
    // Conditionally render the button based on the status
    const isDisabled = props.data.status === 8;
  
    return (
      <div>
        <button
          onClick={handleEditClick}
          className={`custom-btn f12 label label-success editItem1 ${isDisabled ? 'disabled' : ''}`}
          title="Edit"
          disabled={isDisabled}
        >
          <i className="icofont icofont-edit"></i> Edit
        </button>
      </div>
    );
  };
  
  export default EditItem1;
